module.exports = __webpack_public_path__ + "static/media/development.1f1eb8bb.svg";